import { defineComponent } from "bitecs";

export const TagWanderComponent = defineComponent({});
